module.exports = __webpack_public_path__ + "static/media/video.479c2a87.mp4";